<template>
  <div class="pc-page1">
        <div class="test_main1 test_main_21">
        
          <div class="ques-wrapper1 ques-space-wrapper1 test_detail1 test_detail_ing1 test_21 test_detail_space1">
            <div class="timebox1 fr1" v-if="tip == 0">
              剩余时间：
              <div class="time">{{ leftTime }}s</div>
            </div>
            <div class="ques-container1 box1 d-1">
              <div class="d-relative1 ques-answer1 ques-space-answer1" v-show = "tip == 0">
                <div class="d-absolute1 left-operation1" v-if="tip == 0">
                  <img
                    class="operation1"
                    src="../../../../../public/imgs/careerEvaluation/dongshou/32.png"
                    @click="redMoveLeft"
                    alt=""
                  />
                  <img
                    class="operation1"
                    src="../../../../../public/imgs/careerEvaluation/dongshou/33.png"
                    v-bind:style="{ transform: 'rotate(' + redRotate + 'deg)' }"
                    alt=""
                  />
                  <img
                    class="operation1"
                    src="../../../../../public/imgs/careerEvaluation/dongshou/34.png"
                    @click="redMoveRight"
                    alt=""
                  />
                </div>
                <div class="d-absolute1 operation1 right-operation1" v-if="tip == 0"
                >
                  <img
                    class="operation1"
                    src="../../../../../public/imgs/careerEvaluation/dongshou/35.png"
                    @click="blueMoveLeft"
                    alt=""
                  />
                  <img
                    class="operation1"
                    src="../../../../../public/imgs/careerEvaluation/dongshou/36.png"
                    v-bind:style="{
                      transform: 'rotate(' + blueRotate + 'deg)',
                    }"
                    alt=""
                  />
                  <img
                    class="operation1"
                    src="../../../../../public/imgs/careerEvaluation/dongshou/37.png"
                    @click="blueMoveRight"
                    alt=""
                  />
                </div>

                <img
                  class="d-absolute1 red-pos1"
                  v-cloak
                  v-bind:style="{ left: redLeft + 'px', top: redTop + 'px' }"
                  src="../../../../../public/imgs/careerEvaluation/dongshou/28.png"
                  alt=""
                />
                <img
                  class="d-absolute1 blue-pos1"
                  v-cloak
                  v-bind:style="{ left: blueLeft + 'px', top: blueTop + 'px' }"
                  src="../../../../../public/imgs/careerEvaluation/dongshou/29.png"
                  alt=""
                />
                <img
                  class="d-absolute1 end-pos1"
                  src="../../../../../public/imgs/careerEvaluation/dongshou/30.png"
                  alt=""
                />
              </div>
              <!--<div class="ques-answer-tip" v-if="tip==1" @click="clickStart">点击鼠标,开始测试</div>-->
                <div class="box1" v-if="tip == 1" @click="clickStart">
                <em class="icon1 part_start1"></em>
                <div class="btn_warp">
                  <button>
                    <a href="javascript:;" class="btn btn_start"
                    >{{type=='test'?'点击鼠标开始练习':'点击鼠标开始测试'}}</a
                  >
                  </button>
                </div>
              </div>
            </div>
          </div>
         
        </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      seq: this.$route.query.seq,
      type: this.$route.query.type,
      tip: 1,
      subject: 1,
      questions: "",
      answers: [],
      bar: "",
      time: "",
      startTime: "",
      endTime: "",
      redLeft: 395,
      redTop: 450,
      blueLeft: 395,
      blueTop: 50,
      redRotate: 0,
      blueRotate: 0,
      space_direction_deviation: "", //	number	是	方向偏差 （浮点数）		55.7777
      red_space_direction_deviation: "", //	number	是	方向偏差 （浮点数）		55.7777
      blue_space_direction_deviation: "", //	number	是	方向偏差 （浮点数）		55.7777
      space_range_deviation: "", //		number	是	距离偏差（浮点数）		22.444
      space_response_latency: "", //		number	是	反应潜伏期（ms）		5000
      space_reaction_frequency: "", //		number	是	反应频率（浮点数）		12.45
      space_time: "", //		number	是	投入时间(ms)
      firstClick: 1, // 代表第一次点击
      clickCount: 0, // 点击次数
      firstClickTime: "",
      clock: 20,
      timer: "",
      leftTime: 20,
      spaceTime:0,
      indexStatus:-1,
      url2:{ path:'/careerevalution/guide',query: { name:'znsp',part:'znsp81'}},
    };
  },
  mounted() {

  },
  updated() {},
  beforeDestroyed() {
    for (var i = 1; i < 100000; i++) {
      clearInterval(i);
    }
  },
  methods: {
    clickStart: function () {
      if(this.seq==1){
        window.sessionStorage.setItem('znsp81Time',new Date().getTime())
      }
      this.startTime = new Date().getTime();
      this.tip = 0;
      var _this = this;
      setTimeout(function () {
        if (_this.type == "test") {
          sessionStorage.setItem("kongTest81", 1);
          _this.$router.push({
            path: "/careerevalution/success",
            query: {
                type: "test",
                url:_this.url2,
          },
        });
        } else {
          var kongAnswers = [];
          var obj = {};
          // 距离偏差
          var redPositionLeft = $(".red-pos1").position().left;
          var redPositionTop = $(".red-pos1").position().top;
          var bluePositionLeft = $(".blue-pos1").position().left;
          var bluePositionTop = $(".blue-pos1").position().top;
          var redSpaceRange = Math.sqrt(
            (redPositionLeft - 400) * (redPositionLeft - 400) +
              (redPositionTop - 300) * (redPositionTop - 300)
          );
          var blueSpaceRange = Math.sqrt(
            (bluePositionLeft - 400) * (bluePositionLeft - 400) +
              (bluePositionTop - 300) * (bluePositionTop - 300)
          );
          _this.space_range_deviation = redSpaceRange + blueSpaceRange;
          _this.space_range_deviation = parseFloat(
          _this.space_range_deviation.toFixed(2)
          );

          // 方向偏差
          _this.dirRedDeviationCalca();
          _this.dirBlueDeviationCalca();
          _this.space_direction_deviation = parseFloat(
            Number(_this.red_space_direction_deviation) +
              Number(_this.blue_space_direction_deviation)
          );
          obj.spacePositionDeviation = _this.space_range_deviation;
          if (_this.seq == 1) {
            sessionStorage.removeItem("kongAnswers");
            kongAnswers.push(obj);
            kongAnswers = JSON.stringify(kongAnswers);
            sessionStorage.kongAnswers = kongAnswers;
            // console.log(sessionStorage.kongAnswers);
          } else {
            var sessionKongAnswers = JSON.parse(sessionStorage.kongAnswers);
            sessionKongAnswers.push(obj);
            sessionKongAnswers = JSON.stringify(sessionKongAnswers);
            sessionStorage.kongAnswers = sessionKongAnswers;
          }
          if (_this.seq == 6) {
           _this.saveNode(2,91,()=>{
              _this.submit()
            })
          } else {
            _this.$router.push({
              path: "/careerevalution/success",
              query: {
                seq: _this.seq,
              },
            });

          }
        }
      }, 20 * 1000);
      $(".red-pos1").animate(
        {
          left: -15 + "px",
          top: this.redTop + "px",
        },
        20 * 1000,
        "linear"
      );
      $(".blue-pos1").animate(
        {
          left: 800,
          top: this.blueTop + "px",
        },
        20000,
        "linear"
      );
      // _this.timerInit();
      let t = setInterval(function () {
        if (_this.leftTime > 0) {
          _this.leftTime--;
        }else{
          clearInterval(t)
        }
      }, 1000);
    },

    /**
     * 计算红点的方向偏差
     */
    dirRedDeviationCalca: function () {
      var positionLeft, // 相对于容器的left值
        positionTop, // 相对于容器的top值
        angleSin, // 正弦值
        angleCos, // 余弦值
        tempTop, // 移动top值
        tempLeft, // 移动left值
        rotate; // 当前偏移角度
      positionLeft = $(".red-pos1").position().left;
      positionTop = $(".red-pos1").position().top;

      if (this.redRotate >= 0 && this.redRotate < 90) {
        rotate = Math.abs(this.redRotate);
        // 红色方块当前运动方向的角度
        angleSin = Math.sin((rotate * Math.PI) / 180); // 10度的正弦值
        angleCos = Math.cos((rotate * Math.PI) / 180); // 10度的余弦值
        tempTop = positionTop - angleSin * 500; // 移动的top值
        tempLeft = positionLeft - angleCos * 500; // 移动的top值
      }

      if (this.redRotate >= 90 && this.redRotate < 180) {
        rotate = this.redRotate - 90;
        // 红色方块当前运动方向的角度
        angleSin = Math.sin((rotate * Math.PI) / 180); // 10度的正弦值
        angleCos = Math.cos((rotate * Math.PI) / 180); // 10度的余弦值
        tempTop = positionTop - angleCos * 500; // 移动的top值
        tempLeft = positionLeft + angleSin * 500; // 移动的top值
      }

      if (this.redRotate >= 180 && this.redRotate < 270) {
        rotate = Math.abs(this.redRotate) - 180;
        // 红色方块当前运动方向的角度
        angleSin = Math.sin((rotate * Math.PI) / 180); // 10度的正弦值
        angleCos = Math.cos((rotate * Math.PI) / 180); // 10度的余弦值
        tempTop = positionTop + angleSin * 500; // 移动的top值
        tempLeft = positionLeft + angleCos * 500; // 移动的top值
      }

      if (this.redRotate >= 270 && this.redRotate < 360) {
        rotate = Math.abs(this.redRotate) - 270;
        // 红色方块当前运动方向的角度
        if (this.redRotate == 360) {
          this.redRotate = 0;
        }
        angleSin = Math.sin((rotate * Math.PI) / 180); // 10度的正弦值
        angleCos = Math.cos((rotate * Math.PI) / 180); // 10度的余弦值
        tempTop = positionTop + angleCos * 500; // 移动的top值
        tempLeft = positionLeft - angleSin * 500; // 移动的top值
      }

      // console.log(tempLeft);
      // console.log(tempTop);
      var angleAlen = this.pointLengthCalca(
        positionLeft,
        positionTop,
        400,
        300
      );
      var angleBlen = this.pointLengthCalca(
        positionLeft,
        positionTop,
        tempLeft,
        tempTop
      );
      var angleClen = this.pointLengthCalca(tempLeft, tempTop, 400, 300);
      // console.log(angleAlen);
      // console.log(angleBlen);
      // console.log(angleClen);

      var redDirCos =
        (angleAlen * angleAlen +
          angleBlen * angleBlen -
          angleClen * angleClen) /
        (2 * angleAlen * angleBlen);
      this.red_space_direction_deviation =
        (Math.acos(redDirCos) * 180) / Math.PI;
    },

    /**
     * 记录蓝点的方向偏差
     */
    dirBlueDeviationCalca: function () {
      var positionLeft, // 相对于容器的left值
        positionTop, // 相对于容器的top值
        angleSin, // 正弦值
        angleCos, // 余弦值
        tempTop, // 移动top值
        tempLeft, // 移动left值
        rotate; // 当前偏移角度
      positionLeft = $(".blue-pos1").position().left;
      positionTop = $(".blue-pos1").position().top;

      if (this.blueRotate >= 0 && this.blueRotate < 90) {
        rotate = Math.abs(this.blueRotate);
        // 蓝色方块当前运动方向的角度
        angleSin = Math.sin((rotate * Math.PI) / 180); // 10度的正弦值
        angleCos = Math.cos((rotate * Math.PI) / 180); // 10度的余弦值
        tempTop = positionTop + angleSin * 500; // 移动的top值
        tempLeft = positionLeft + angleCos * 500; // 移动的top值
      }

      if (this.blueRotate >= 90 && this.blueRotate < 180) {
        rotate = this.blueRotate - 90;
        // 蓝色方块当前运动方向的角度
        this.blueRotate += 10;
        angleSin = Math.sin((rotate * Math.PI) / 180); // 10度的正弦值
        angleCos = Math.cos((rotate * Math.PI) / 180); // 10度的余弦值
        tempTop = positionTop + angleCos * 500; // 移动的top值
        tempLeft = positionLeft - angleSin * 500; // 移动的top值
      }

      if (this.blueRotate >= 180 && this.blueRotate < 270) {
        rotate = Math.abs(this.blueRotate) - 180;
        // 蓝色方块当前运动方向的角度
        angleSin = Math.sin((rotate * Math.PI) / 180); // 10度的正弦值
        angleCos = Math.cos((rotate * Math.PI) / 180); // 10度的余弦值
        tempTop = positionTop - angleSin * 500; // 移动的top值
        tempLeft = positionLeft - angleCos * 500; // 移动的top值
      }

      if (this.blueRotate >= 270 && this.blueRotate < 360) {
        rotate = Math.abs(this.blueRotate) - 270;
        // 蓝色方块当前运动方向的角度
        this.blueRotate += 10;
        if (this.blueRotate == 360) {
          this.blueRotate = 0;
        }
        angleSin = Math.sin((rotate * Math.PI) / 180); // 10度的正弦值
        angleCos = Math.cos((rotate * Math.PI) / 180); // 10度的余弦值
        tempTop = positionTop - angleCos * 500; // 移动的top值
        tempLeft = positionLeft + angleSin * 500; // 移动的top值
      }

      // console.log(tempLeft);
      // console.log(tempTop);
      var angleAlen = this.pointLengthCalca(
        positionLeft,
        positionTop,
        400,
        300
      );
      var angleBlen = this.pointLengthCalca(
        positionLeft,
        positionTop,
        tempLeft,
        tempTop
      );
      var angleClen = this.pointLengthCalca(tempLeft, tempTop, 400, 300);
      // console.log(angleAlen);
      // console.log(angleBlen);
      // console.log(angleClen);

      var redDirCos =
        (angleAlen * angleAlen +
          angleBlen * angleBlen -
          angleClen * angleClen) /
        (2 * angleAlen * angleBlen);
      this.blue_space_direction_deviation =
        (Math.acos(redDirCos) * 180) / Math.PI;
    },

    /**
     * 根据两点坐标求直线长度
     */
    pointLengthCalca: function (left1, top1, left2, top2) {
      var angleLen = Math.sqrt(
        (left2 - left1) * (left2 - left1) + (top2 - top1) * (top2 - top1)
      );
      return angleLen;
    },

    tabSwitch: function (e) {
      this.subject = $(e.target).attr("cid");
    },

    /**
     * red div move to left
     */
    redMoveLeft: function () {
      this.clickCount++;
      if(this.indexStatus!=this.seq){
                this.indexStatus=this.seq;
                if(this.type=='test'){

                }else{
                  if(sessionStorage.getItem("spaceTime") && sessionStorage.getItem("spaceTime")!=''){
                    let time=Number(sessionStorage.getItem("spaceTime"))
                    time += 20000;
                    sessionStorage.setItem("spaceTime",time);
                  }else{
                    this.spaceTime+=20000
                    sessionStorage.setItem("spaceTime",this.spaceTime);
                  }
                }
            }
      var positionLeft, // 相对于容器的left值
        positionTop, // 相对于容器的top值
        angleSin, // 正弦值
        angleCos, // 余弦值
        tempTop, // 移动top值
        tempLeft, // 移动left值
        rotate; // 当前偏移角度
      positionLeft = $(".red-pos1").position().left;
      positionTop = $(".red-pos1").position().top;

      if (this.redRotate == 0) {
        this.redRotate = 360;
      }

      if (this.redRotate <= 360 && this.redRotate > 270) {
        rotate = 370 - Math.abs(this.redRotate);
        // 红色方块当前运动方向的角度
        this.redRotate -= 10;
        angleSin = Math.sin((rotate * Math.PI) / 180); // 10度的正弦值
        angleCos = Math.cos((rotate * Math.PI) / 180); // 10度的余弦值
        tempTop = positionTop + angleSin * 500; // 移动的top值
        tempLeft = positionLeft - angleCos * 500; // 移动的top值
      }

      if (this.redRotate <= 270 && this.redRotate > 180) {
        rotate = 280 - Math.abs(this.redRotate);
        // 红色方块当前运动方向的角度
        this.redRotate -= 10;
        angleSin = Math.sin((rotate * Math.PI) / 180); // 10度的正弦值
        angleCos = Math.cos((rotate * Math.PI) / 180); // 10度的余弦值
        tempTop = positionTop + angleCos * 500; // 移动的top值
        tempLeft = positionLeft + angleSin * 500; // 移动的top值
      }

      if (this.redRotate <= 180 && this.redRotate > 90) {
        rotate = 190 - Math.abs(this.redRotate);
        // 红色方块当前运动方向的角度
        this.redRotate -= 10;
        angleSin = Math.sin((rotate * Math.PI) / 180); // 10度的正弦值
        angleCos = Math.cos((rotate * Math.PI) / 180); // 10度的余弦值
        tempTop = positionTop - angleSin * 500; // 移动的top值
        tempLeft = positionLeft + angleCos * 500; // 移动的top值
      }

      if (this.redRotate <= 90 && this.redRotate > 0) {
        rotate = 100 - Math.abs(this.redRotate);
        // 红色方块当前运动方向的角度
        this.redRotate -= 10;
        angleSin = Math.sin((rotate * Math.PI) / 180); // 10度的正弦值
        angleCos = Math.cos((rotate * Math.PI) / 180); // 10度的余弦值
        tempTop = positionTop - angleCos * 500; // 移动的top值
        tempLeft = positionLeft - angleSin * 500; // 移动的top值
      }
      $(".red-pos1")
        .stop()
        .animate(
          { left: tempLeft + "px", top: tempTop + "px" },
          20 * 1000,
          "linear"
        );
    },

    /**
     * red div move to right
     */
    redMoveRight: function () {
      this.clickCount++;
     if(this.indexStatus!=this.seq){
                this.indexStatus=this.seq;
        if(this.type == "test"){

        }else{
          if(sessionStorage.getItem("spaceTime") && sessionStorage.getItem("spaceTime")!=''){
            let time=Number(sessionStorage.getItem("spaceTime"))
            time += 20000;
            sessionStorage.setItem("spaceTime",time);
          }else{
            this.spaceTime+=20000
            sessionStorage.setItem("spaceTime",this.spaceTime);
          }
        }
      }
      var positionLeft, // 相对于容器的left值
        positionTop, // 相对于容器的top值
        angleSin, // 正弦值
        angleCos, // 余弦值
        tempTop, // 移动top值
        tempLeft, // 移动left值
        rotate; // 当前偏移角度
      positionLeft = $(".red-pos1").position().left;
      positionTop = $(".red-pos1").position().top;

      if (this.redRotate >= 0 && this.redRotate < 90) {
        rotate = Math.abs(this.redRotate) + 10;
        // 红色方块当前运动方向的角度
        this.redRotate += 10;
        angleSin = Math.sin((rotate * Math.PI) / 180); // 10度的正弦值
        angleCos = Math.cos((rotate * Math.PI) / 180); // 10度的余弦值
        tempTop = positionTop - angleSin * 500; // 移动的top值
        tempLeft = positionLeft - angleCos * 500; // 移动的top值
      }

      if (this.redRotate >= 90 && this.redRotate < 180) {
        rotate = this.redRotate - 90;
        // 红色方块当前运动方向的角度
        this.redRotate += 10;
        angleSin = Math.sin((rotate * Math.PI) / 180); // 10度的正弦值
        angleCos = Math.cos((rotate * Math.PI) / 180); // 10度的余弦值
        tempTop = positionTop - angleCos * 500; // 移动的top值
        tempLeft = positionLeft + angleSin * 500; // 移动的top值
      }

      if (this.redRotate >= 180 && this.redRotate < 270) {
        rotate = Math.abs(this.redRotate) - 180;
        // 红色方块当前运动方向的角度
        this.redRotate += 10;
        angleSin = Math.sin((rotate * Math.PI) / 180); // 10度的正弦值
        angleCos = Math.cos((rotate * Math.PI) / 180); // 10度的余弦值
        tempTop = positionTop + angleSin * 500; // 移动的top值
        tempLeft = positionLeft + angleCos * 500; // 移动的top值
      }

      if (this.redRotate >= 270 && this.redRotate < 360) {
        rotate = Math.abs(this.redRotate) - 270;
        // 红色方块当前运动方向的角度
        this.redRotate += 10;
        if (this.redRotate == 360) {
          this.redRotate = 0;
        }
        angleSin = Math.sin((rotate * Math.PI) / 180); // 10度的正弦值
        angleCos = Math.cos((rotate * Math.PI) / 180); // 10度的余弦值
        tempTop = positionTop + angleCos * 500; // 移动的top值
        tempLeft = positionLeft - angleSin * 500; // 移动的top值
      }
      $(".red-pos1")
        .stop()
        .animate(
          { left: tempLeft + "px", top: tempTop + "px" },
          20 * 1000,
          "linear"
        );
    },

    /**
     * blue div move to left
     */
    blueMoveLeft: function () {
     
      this.clickCount++;
     if(this.indexStatus!=this.seq){
                this.indexStatus=this.seq;
                if(sessionStorage.getItem("spaceTime") && sessionStorage.getItem("spaceTime")!=''){
                    let time=Number(sessionStorage.getItem("spaceTime"))
                    time += 20000;
                    sessionStorage.setItem("spaceTime",time);
                }else{
                    this.spaceTime+=20000
                    sessionStorage.setItem("spaceTime",this.spaceTime);
                }
                console.log(this.spaceTime)
      }
      var positionLeft, // 相对于容器的left值
        positionTop, // 相对于容器的top值
        angleSin, // 正弦值
        angleCos, // 余弦值
        tempTop, // 移动top值
        tempLeft, // 移动left值
        rotate; // 当前偏移角度
      positionLeft = $(".blue-pos1").position().left;
      positionTop = $(".blue-pos1").position().top;

      if (this.blueRotate == 0) {
        this.blueRotate = 360;
      }

      if (this.blueRotate <= 360 && this.blueRotate > 270) {
        rotate = 370 - Math.abs(this.blueRotate);
        // 蓝色方块当前运动方向的角度
        this.blueRotate -= 10;
        angleSin = Math.sin((rotate * Math.PI) / 180); // 10度的正弦值
        angleCos = Math.cos((rotate * Math.PI) / 180); // 10度的余弦值
        tempTop = positionTop - angleSin * 500; // 移动的top值
        tempLeft = positionLeft + angleCos * 500; // 移动的top值
      }

      if (this.blueRotate <= 270 && this.blueRotate > 180) {
        rotate = 280 - Math.abs(this.blueRotate);
        // 蓝色方块当前运动方向的角度
        this.blueRotate -= 10;
        angleSin = Math.sin((rotate * Math.PI) / 180); // 10度的正弦值
        angleCos = Math.cos((rotate * Math.PI) / 180); // 10度的余弦值
        tempTop = positionTop - angleCos * 500; // 移动的top值
        tempLeft = positionLeft - angleSin * 500; // 移动的top值
      }

      if (this.blueRotate <= 180 && this.blueRotate > 90) {
        rotate = 190 - Math.abs(this.blueRotate);
        // 蓝色方块当前运动方向的角度
        this.blueRotate -= 10;
        angleSin = Math.sin((rotate * Math.PI) / 180); // 10度的正弦值
        angleCos = Math.cos((rotate * Math.PI) / 180); // 10度的余弦值
        tempTop = positionTop + angleSin * 500; // 移动的top值
        tempLeft = positionLeft - angleCos * 500; // 移动的top值
      }

      if (this.blueRotate <= 90 && this.blueRotate > 0) {
        rotate = 100 - Math.abs(this.blueRotate);
        // 蓝色方块当前运动方向的角度
        this.blueRotate -= 10;
        angleSin = Math.sin((rotate * Math.PI) / 180); // 10度的正弦值
        angleCos = Math.cos((rotate * Math.PI) / 180); // 10度的余弦值
        tempTop = positionTop + angleCos * 500; // 移动的top值
        tempLeft = positionLeft + angleSin * 500; // 移动的top值
      }
      $(".blue-pos1")
        .stop()
        .animate(
          { left: tempLeft + "px", top: tempTop + "px" },
          20 * 1000,
          "linear"
        );
    },

    /**
     * blue div move to right
     */
    blueMoveRight: function () {
      this.clickCount++;
    if(this.indexStatus!=this.seq){
                this.indexStatus=this.seq;
                if(sessionStorage.getItem("spaceTime") && sessionStorage.getItem("spaceTime")!=''){
                    let time=Number(sessionStorage.getItem("spaceTime"))
                    time += 20000;
                    sessionStorage.setItem("spaceTime",time);
                }else{
                    this.spaceTime+=20000
                    sessionStorage.setItem("spaceTime",this.spaceTime);
                }
               // console.log(this.spaceTime)
            }
      var positionLeft, // 相对于容器的left值
        positionTop, // 相对于容器的top值
        angleSin, // 正弦值
        angleCos, // 余弦值
        tempTop, // 移动top值
        tempLeft, // 移动left值
        rotate; // 当前偏移角度
      positionLeft = $(".blue-pos1").position().left;
      positionTop = $(".blue-pos1").position().top;

      if (this.blueRotate >= 0 && this.blueRotate < 90) {
        rotate = Math.abs(this.blueRotate) + 10;
        // 蓝色方块当前运动方向的角度
        this.blueRotate += 10;
        angleSin = Math.sin((rotate * Math.PI) / 180); // 10度的正弦值
        angleCos = Math.cos((rotate * Math.PI) / 180); // 10度的余弦值
        tempTop = positionTop + angleSin * 500; // 移动的top值
        tempLeft = positionLeft + angleCos * 500; // 移动的top值
      }

      if (this.blueRotate >= 90 && this.blueRotate < 180) {
        rotate = this.blueRotate - 90;
        // 蓝色方块当前运动方向的角度
        this.blueRotate += 10;
        angleSin = Math.sin((rotate * Math.PI) / 180); // 10度的正弦值
        angleCos = Math.cos((rotate * Math.PI) / 180); // 10度的余弦值
        tempTop = positionTop + angleCos * 500; // 移动的top值
        tempLeft = positionLeft - angleSin * 500; // 移动的top值
      }

      if (this.blueRotate >= 180 && this.blueRotate < 270) {
        rotate = Math.abs(this.blueRotate) - 180;
        // 蓝色方块当前运动方向的角度
        this.blueRotate += 10;
        angleSin = Math.sin((rotate * Math.PI) / 180); // 10度的正弦值
        angleCos = Math.cos((rotate * Math.PI) / 180); // 10度的余弦值
        tempTop = positionTop - angleSin * 500; // 移动的top值
        tempLeft = positionLeft - angleCos * 500; // 移动的top值
      }

      if (this.blueRotate >= 270 && this.blueRotate < 360) {
        rotate = Math.abs(this.blueRotate) - 270;
        // 蓝色方块当前运动方向的角度
        this.blueRotate += 10;
        if (this.blueRotate == 360) {
          this.blueRotate = 0;
        }
        angleSin = Math.sin((rotate * Math.PI) / 180); // 10度的正弦值
        angleCos = Math.cos((rotate * Math.PI) / 180); // 10度的余弦值
        tempTop = positionTop - angleCos * 500; // 移动的top值
        tempLeft = positionLeft + angleSin * 500; // 移动的top值
      }
      $(".blue-pos1")
        .stop()
        .animate(
          { left: tempLeft + "px", top: tempTop + "px" },
          20 * 1000,
          "linear"
        );
    },

    /**
     * 答题
     */
    answerClick: function (e) {
      var _this = this;
      setTimeout(function () {
        _this.subject = $(".ques-item").attr("paper");
      }, 100);
      $(e.target).closest(".answer-item").addClass("active");
      var score = $(e.target).closest(".answer-item").attr("score");
      var paper = $(e.target).closest(".ques-item").attr("paper");
      var question_id = $(e.target).closest(".ques-item").attr("cid");
      this.answers.push({
        question_id: question_id,
        paper: paper,
        score: score,
      });
      if (this.curIndex == 1) {
        this.startTime = new Date().getTime();
      }
      if (this.curIndex < this.total) {
        this.curIndex++;
        this.bar = (Number(this.curIndex - 1) / Number(this.total)) * 100;
        setTimeout(function () {
          $(".answer-item").removeClass("active");
        }, 100);
        console.log(this.currentIndex,this.total)
      } else {;
        this.bar = 100;
        this.endTime = new Date().getTime(); //结束时间
        this.time = Number(this.endTime) - Number(this.startTime);
        this.saveNode(2,91,()=>{
          this.submit()
        })
      }
    },

    /**
     * 提交
     */
    submit: function () {
      for (var i = 1; i < 100; i++) {
        clearInterval(i);
      }
      this.time = Number(new Date().getTime()) - Number(window.sessionStorage.getItem('znsp81Time'));
      this.space_time = Number(new Date().getTime()) - Number(this.startTime);
      this.$ajax
        .post(
          `${this.G_capi}${this.ports.careerEvaluation.znsp.stydnlAdd1}`,
          {
            time: this.time,
            spaceTime:Number(sessionStorage.getItem("spaceTime")),
            testId: sessionStorage.getItem("testId"),
            answers: JSON.parse(sessionStorage.getItem('kongAnswers'),)
            //            answers: '[{"space_direction_deviation":21,"space_range_deviation":30,"space_response_latency":506,"space_reaction_frequency":13,"space_time":506}]'
          },
          {
            timeout: 3000,
            headers: {
              token: sessionStorage.getItem("token"),
            },
          },
          // {
          //   emulateJSON: true,
          // }
        )
        .then(
          function (res) {
            var data = res.data;
            if(data.code==2000){
              window.sessionStorage.removeItem('spaceTime')
              window.sessionStorage.removeItem('kongAnswers')
              window.sessionStorage.removeItem('znsp81Time')
              this.$router.push({
                path: "/careerevalution/success",
                query: {
                  seq: this.seq,
                },
              });
            }
          }.bind(this),
          function (res) {
           this.$message.error("网络错误 请重新提交");
          }.bind(this)
        );
    },
  },
};
</script>

<style scoped>
.seq-wrapper1 {
  position: absolute;
  bottom: 10px;
  right: 10px;
  font-size: 17px;
}
[v-cloak] {
  display: none !important;
}
</style>

<style>
/* .dati_bg{
    padding: 0;
  } */
.evalu-nav1 {
  background: #333;
  opacity: 1;
}

.test_main_21 .test_detail_space1 {
  height: 510px;
  background-size: 100% 100%;
}
.test_detail_ing1 .timebox1 {
  font-size: 16px;
  color: #666666;
  line-height: 50px;
  position: absolute;
  top: 40px;
  z-index: 1000;
  right: -40px;
}
.test_main_21 .test_detail_space1 .timebox1 .time {
  line-height: 40px;
}

.test_detail_ing1 .timebox1 .time {
  display: inline-block;
  background: #7f8ca5;
  width: auto;
  text-align: center;
  border-radius: 5px;
  font-size: 24px;
  color: #fff;
  line-height: 50px;
  padding: 0 20px;
}
.test_main_21 .test_detail_space1 .timebox1 {
  top: -44px;
}
.test_detail1 {
  position: relative;
  top: 10px;
}
.test_detail_ing1 .box1 {
  top: 0;
}
.ques-wrapper1 .ques-container1 .ques-space-answer1 {
  width: 800px;
  margin: 0 auto 0;
  height: 510px;
}
.ques-wrapper1 .ques-container1 .ques-answer1 {
  border: 1px solid #ececed;
  moz-user-select: -moz-none;
  -moz-user-select: none;
  -o-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  position: relative;
}
.d-relative1 {
  position: relative !important;
}
.d-absolute1 {
  position: absolute !important;
}
.ques-wrapper1 .ques-container1 .ques-space-answer1 .left-operation1 {
  top: -40px;
  left: 100px;
}
.ques-wrapper1 .ques-container1 .ques-space-answer1 .right-operation1 {
  top: -40px;
  right: 100px;
}
.ques-wrapper1 .ques-container1 .ques-space-answer1 img.operation1 {
  display: block;
  float: left;
  margin: 0 5px;
  cursor: pointer;
}
.ques-wrapper1 .ques-container1 .ques-space-answer1 .end-pos1 {
  left: 50%;
  top: 50%;
  margin: -14px 0 0 -14px;
}

 .btn_warp{
    display: flex;
    justify-content: space-between;
  }
  /* 按钮 */
  .btn_warp button{
    width: 166px;
    height: 41px;
    background: linear-gradient(90deg, #1FD99C 0%, #1AC6FD 100%);
    border-radius: 21px;
    border: none;
    color: #fff;
    font-size: 16px;
    margin: 40px auto 0;
    display: block;
  }
  .test_main1 .box1{
    display: flex;
    justify-content: center;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .box1 .part_start1 {
    background: url("../../../../../public/imgs/careerEvaluation/start.png") no-repeat center;
    background-size: cover;
}

.box1 .icon1 {
    display: inline-block;
    margin-top: 150px;
    width: 176px;
    height: 130px;
}
</style>
